var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pg-table-input"},[_c('span',[_vm._v(_vm._s(_vm.pre))]),_c('input',{class:_vm.inputClass,style:({width:_vm.width}),attrs:{"readonly":""},domProps:{"value":_vm.value}}),_c('span',[_vm._v(_vm._s(_vm.suf))])])
}
var staticRenderFns = []

export { render, staticRenderFns }